module.exports = "pegasus/assets/themelp1/app/100.png";